export function indexMenuPermissions (menus) {
  const nodes = Object.create(null)
  const parents = Object.create(null)

  const walk = (items, parent) => {
    const menuItems = items || []
    menuItems.forEach(item => {
      nodes[item.alias_name] = item
      parents[item.alias_name] = parent || null
      walk(item.children, item)
      walk(item.childrenButton, item)
    })
  }

  walk(menus, null)
  return { nodes, parents }
}

export function isMenuPermissionButton (menu) {
  return !!menu && Number(menu.is_menu) === 0
}

export function getDescendantMenuPermissionButtons (menu) {
  const buttons = []

  const walkButtons = items => {
    const menuItems = items || []
    menuItems.forEach(item => {
      if (isMenuPermissionButton(item)) buttons.push(item)
    })
  }

  const walkMenus = items => {
    const menuItems = items || []
    menuItems.forEach(item => {
      walkButtons(item.childrenButton)
      walkMenus(item.children)
    })
  }

  walkButtons(menu && menu.childrenButton)
  walkMenus(menu && menu.children)
  return buttons
}

/**
 * 角色权限树展示用：把 childrenButton 合并进 children，供 el-tree 勾选。
 * 导航菜单仍保持 children / childrenButton 分离。
 */
export function mergeMenuPermissionButtonsIntoChildren (menus) {
  return (menus || []).map(item => {
    const children = mergeMenuPermissionButtonsIntoChildren(item.children || [])
    const buttons = item.childrenButton || []
    const merged = {
      ...item,
      children: [...children, ...buttons]
    }
    delete merged.childrenButton
    return merged
  })
}

export function hasMenuPermission (menus, parentAlias, buttonAlias) {
  const { nodes, parents } = indexMenuPermissions(menus)
  const parent = nodes[parentAlias]
  const button = nodes[buttonAlias]

  return !!(
    parent &&
    button &&
    isMenuPermissionButton(button) &&
    parents[buttonAlias] &&
    parents[buttonAlias].alias_name === parentAlias
  )
}
